module.exports = __webpack_public_path__ + "static/img/top.86bf114.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/company/top.png
// module id = UXwp
// module chunks = 1